"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BestOffers = void 0;
var _react = require("react");
var _hooks = require("../../../hooks");
var _DesktopBestOffers = require("./DesktopBestOffers");
var _MobileBestOffers = require("./MobileBestOffers");
var _jsxRuntime = require("react/jsx-runtime");
const BestOffers = ({
  content
}) => {
  const isMobile = (0, _hooks.useIsMobile)();
  const areBestOffersValid = (0, _react.useMemo)(() => content?.some(item => item.children.length > 0), [content]);
  if (content?.length === 0 || !areBestOffersValid) {
    return null;
  }
  if (isMobile) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MobileBestOffers.MobileBestOffers, {
      content: content
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DesktopBestOffers.DesktopBestOffers, {
    content: content
  });
};
exports.BestOffers = BestOffers;